import { useQuery } from "@tanstack/react-query";
import { contractorApi } from "../api/contractorApi";
import { FilterItem } from "../../../shared/context/FilterContext";
import { extractFilterValues } from "../../../lib/filterUtils";

export const useFetchContractor = ({ quickFilters }: { quickFilters: any }) => {

    const { data, isFetching, isPending, isError, error, refetch } = useQuery({
        queryKey: ["contractors", quickFilters],
        queryFn: () => {
            const params = {
                workstream_id: extractFilterValues(quickFilters.workstream) || null,
                site_id: extractFilterValues(quickFilters.site) || null,
                programme_id: extractFilterValues(quickFilters.programme) || null,
                region_id: extractFilterValues(quickFilters.region) || null,
                work_type_group_id: extractFilterValues(quickFilters['worktype-group']) || null,
            };
            return contractorApi.fetchCards(params)
        },
    });

    return {
        data,
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };

};
